<div *ngIf="!hidden">
  <mat-list-item *ngIf="!value" (click)="value = !value">
    <span class="full-width" *ngIf="isExpanded || isShowing"
      >View History Log</span
    >
    <mat-icon matListItemIcon class="blue">history</mat-icon>
  </mat-list-item>

  <mat-list-item *ngIf="value" (click)="value = !value">
    <span class="full-width" *ngIf="isExpanded || isShowing"
      >Hide History Log</span
    >
    <mat-icon matListItemIcon class="grey material-symbols-outlined"
      >history_off</mat-icon
    >
  </mat-list-item>
</div>
